import { DIALOGS } from '@/constants/dialogs';

export const SHORTCUT_KEYS = {
  '\\C': DIALOGS.ACCOUNTS,
  '\\E': DIALOGS.SUMMARY_REPORT_EXPORT,
} as const;
